import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../../js/stores/language.js';
import buyoutDeposit from '../../../js/stores/buyout-deposit.js';
function framework7Component(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var buyoutList = [];
  $f7.on('fillDashboardGrid', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return buyoutDeposit.dispatch('getFullList');
        case 1:
          result = _context.sent;
          if (result.status !== undefined && result.status !== 200) {
            console.log(result.data.messages.error);
            result = [];
          }
          buyoutList = result;
          $update();
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return $f7.emit('fillDashboardGrid');
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  $on('pageBeforeRemove', function () {
    $f7.off('fillDashboardGrid');
  });
  var goBuyoutDepositEdit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
      var anchor, buyoutDepositId, BuyoutDepositItem, obj;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            e.preventDefault();
            anchor = e.target.closest("a");
            buyoutDepositId = anchor.dataset.buyoutDepositId;
            BuyoutDepositItem = buyoutList.filter(function (item) {
              return item.BuyoutDepositId == buyoutDepositId;
            })[0];
            if (!(Number(BuyoutDepositItem.BuyoutDepositFee) == 0)) {
              _context3.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('admin.sections.buyoutDeposit.messageNoEdited'),
              closeTimeout: 4000
            });
            return _context3.abrupt("return");
          case 1:
            obj = {
              props: BuyoutDepositItem
            };
            $f7.views.main.router.navigate('/car-buyout-deposit-edit/', obj);
            $update();
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function goBuyoutDepositEdit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="car-buyout-deposit-dashboard">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">Back</span>
          </a>
        </div>
        <div class="title">${locale.translate('admin.sections.buyoutDeposit.panelTitle')}</div>
      </div>
    </div>
    <div class="page-content">
      <div id="container" class="center-content">
        <div class="list media-list list-outline-ios list-strong-ios list-dividers-ios">
          <ul>
          ${buyoutList.length > 0 && $h`
          ${buyoutList.map((item) => $h`
            <li>
              <a class="item-link item-content popup-open" data-popup=".buyout-deposit-popup" @click="${goBuyoutDepositEdit}" data-buyout-deposit-id="${item.BuyoutDepositId}">
                <div class="item-inner" >
                  <div class="item-title-row">
                    <div class="item-title">
                      ${locale.translate('admin.sections.buyoutDeposit.feeLabel')}: € ${item.BuyoutDepositFee} | ${locale.translate('admin.sections.buyoutDeposit.toPayLabel')}: € ${item.BuyoutDepositToPay}
                    </div>
                    <div class="item-after">
                      <i class="icon material-symbols-outlined color-green">edit</i>${locale.translate('general.edit')}
                    </div>
                  </div>
                  <div class="item-text">
                    ${locale.translate('admin.sections.buyoutDeposit.displayMessageLabel')}: ${item.BuyoutDepositRecommendationLabel} <br />
                    ${locale.translate('admin.sections.buyoutDeposit.showOptionLabel')}:
                    ${item.BuyoutDepositStatusId > 0 ? $h`<i class="icon material-symbols-outlined color-green">done</i>` : $h`<i class="icon material-symbols-outlined color-red">close</i>`}
                  </div>
                </div>
              </a>
            </li>
          `)}
          `}
          </ul>
        </div>
      </div>
    </div>
  </div>
`
    }
    ;
}
framework7Component.id = '5672d503fc';
export default framework7Component;